import { render, staticRenderFns } from "./project.vue?vue&type=template&id=78d260b6&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/project.css?vue&type=style&index=0&id=78d260b6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d260b6",
  null
  
)

export default component.exports